export const POLICY_COOKIE_NAME = 'accept_policy';
export const POLICY_COOKIE_LIFETIME = 365;
export const ACTIVATE_EMAIL_COOKIE = 'activate_email';
export const ACTIVATE_CONTACT_INFO = 'contact_info';
export const BRANDING_INFO = 'customer_branding';
export const PREVIEW_INFO_TOKEN = 'preview_recipient_flow';
